import React, { FC } from 'react';
import cn from 'classnames';

import { isMobileOrTablet } from 'client/hooks/responsive';
import { vwSizes, vw_dSizes } from 'utils/css-measurements';

import css from './ServiceRateRange.module.scss';
import { formatRateNumber } from 'client/utils/formatRateNumber';

type Props = {
  title: string;
  rate: number;
};

const ServiceRateRange: FC<Props> = ({ title, rate }) => {
  const isMobile = isMobileOrTablet();
  const [isAnimated, setIsAnimated] = React.useState(false);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setIsAnimated(true);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  const calculateRangeProgress = (): number => {
    if (isMobile) {
      return vwSizes((114 / 10) * rate);
    }

    return vw_dSizes((272 / 10) * rate);
  };

  const rangeProgressStyles = () => {
    return `${calculateRangeProgress()}vw`;
  };

  return (
    <div className={cn(css.rateRange, isMobile && css.mobile)}>
      {isMobile ? (
        <div>
          <div className={css.title}>
            <span>{title}</span>
          </div>
          <div className={css.range}>
            <div style={{ width: isAnimated ? rangeProgressStyles() : '0px' }} />
          </div>
        </div>
      ) : (
        <>
          <div className={css.title}>
            <span>{title}</span>
          </div>
          <div className={css.range}>
            <div style={{ width: isAnimated ? rangeProgressStyles() : '0px' }} />
          </div>
        </>
      )}
      <div className={css.numberRate}>
        <span>{formatRateNumber(rate)}</span>
      </div>
    </div>
  );
};

export default ServiceRateRange;
